<div class="rst {{style}}">
	<textarea #qtext (keyup)="resizeTextArea($event)" [value]="initial" (input)="change($event.target.value)"></textarea>
	<i *ngIf="canUpdate" class="material-icons" (click)="update(qtext.value)">done</i>
	<i *ngIf="canCancel" class="material-icons" (click)="cancel()">cancel</i>
</div>
